<template>
  <section v-if="product" id="reviews" :aria-label="$t.reviews"  style="scroll-margin-top: 4.5rem">
    <base-lazy-load>
      <vf-tabs
        v-if="$feature.showReviewQAndAOnPDP"
        :tabs="[$t.reviews, $t.questions]"
        variant="left"
      >
        <template #content-0>
          <div class="pt-6">
            <product-reviews
              :currency="product.currency"
              :data="reviewsData"
              :error="reviewsError"
              :pending="reviewsPending"
              :product-id="product.id"
            />
          </div>
        </template>
        <template #content-1>
          <div class="pt-6">
            <product-reviews-questions
              v-model="questionsQuery"
              :error="questionsError"
              :pending="questionsPending"
              :product-id="product.id"
              :questions-data
            />
          </div>
        </template>
      </vf-tabs>
      <product-reviews
        v-else
        :currency="product.currency"
        :data="reviewsData"
        :error="reviewsError"
        :pending="reviewsPending"
        :product-id="product.id"
      />
    </base-lazy-load>
  </section>
</template>

<script lang="ts" setup>
const {
  product,
  questionsData,
  questionsError,
  questionsPending,
  questionsQuery,
  reviewsData,
  reviewsError,
  reviewsPending,
} = usePdp()
</script>
